/**
 * The page to open after signing in, from the value `ProtectedPage` stored (`pathname + search`),
 * or `null` when it is not a path of this app. The stored value is not trusted as is: a visit to
 * `https://app…//evil.example` stores `//evil.example`, a protocol-relative URL to another site, and
 * anything else able to write the app's localStorage could plant one. Resolving it against our
 * origin also catches the variants browsers normalize into one (`/\evil.example`, a tab in `//`).
 */
export const postLoginTarget = (stored: string | null): string | null => {
  if (!stored?.startsWith('/')) {
    return null;
  }
  try {
    return new URL(stored, window.location.origin).origin === window.location.origin ? stored : null;
  } catch {
    return null;
  }
};
